import {
  Card,
  CardContent,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useEffect, useState } from "react";
import SigneeRegisterInfo from "../popover/SigneeRegisterInfo";
import { shallowEqual, useSelector } from "react-redux";

const TotalCounties = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);

  const { county: uTierCounty, additions: uTierAdditions } = useSelector(
    (state) => state[currentSession]?.user?.tier || {},
    shallowEqual
  );

  const { additions: uAnalyticsAddition } = useSelector(
    (state) => state[currentSession]?.user?.user?.analytics || {},
    shallowEqual
  );

  const [availableCountyTitle, setAvailableCountyTitle] = useState(false);
  const [isCountyFadingOut, setIsCountyFadingOut] = useState(false);
  const [value, setValue] = useState(0);

  const title =
    "This indicate a number of counties accessible to all users within your organization.";
  const miniSize = useMediaQuery("(max-width:330px)");
  const mobileSize = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const tabletSize = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const between905and1125 = useMediaQuery(
    "(min-width:900px) and (max-width:1125px)"
  );
  const between1200and1405 = useMediaQuery(
    "(min-width:1200px) and (max-width:1405px)"
  );

  useEffect(() => {
    const newVal =
      parseInt(uTierCounty || 0) +
        parseInt(uAnalyticsAddition?.numCounties || 0) +
        parseInt(uTierAdditions?.county?.qty || 0) || 0;

    if (newVal !== value) {
      setValue(newVal);
    }
  }, [
    uAnalyticsAddition?.numCounties,
    uTierAdditions?.county?.qty,
    uTierCounty,
    value,
  ]);

  useEffect(() => {
    if (availableCountyTitle) {
      // First timeout to start the fade-out effect after 4500ms
      const availableCountyTimeout = setTimeout(() => {
        setIsCountyFadingOut(true);
        const countyFadeOutTimeout = setTimeout(() => {
          setAvailableCountyTitle(false);
          setIsCountyFadingOut(false);
        }, 1000);

        return () => clearTimeout(countyFadeOutTimeout);
      }, 3500);

      return () => clearTimeout(availableCountyTimeout);
      //? //////////////////////////////////////////////////////////////////////////
    }
  }, [availableCountyTitle, setAvailableCountyTitle]);

  return (
    <Card
      sx={{
        minHeight: mobileSize ? undefined : tabletSize ? "171px" : "203px",
        position: "relative",
      }}
    >
      {tabletSize ? (
        <IconButton
          onClick={() => setAvailableCountyTitle(!availableCountyTitle)}
          sx={{ position: "absolute", right: 0, top: 0 }}
        >
          <HelpOutlineIcon color="primary" />
        </IconButton>
      ) : (
        <Tooltip title={title} placement="top">
          <HelpOutlineIcon
            color="primary"
            sx={{ position: "absolute", right: 10, top: 10 }}
          />
        </Tooltip>
      )}

      {availableCountyTitle && (
        <SigneeRegisterInfo
          infoText={title}
          isFadingOut={isCountyFadingOut}
          top={35}
        />
      )}

      <CardContent
        sx={{
          px: tabletSize ? 1.5 : between1200and1405 ? 1 : undefined,
          pt: mobileSize ? 1.5 : tabletSize ? 3 : undefined,
          pb: tabletSize ? 1.5 : undefined,
        }}
      >
        <Stack
          alignItems="flex-start"
          direction="row"
          justifyContent="space-between"
          spacing={3}
        >
          <Stack spacing={1}>
            <Typography
              color="text.secondary"
              variant={tabletSize ? "h6" : "overline"}
            >
              Total Counties in Your Subscription
            </Typography>
            <Typography variant="h5">{value}</Typography>
          </Stack>
          {!between905and1125 && !miniSize && (
            <Stack>
              <img
                alt="counties"
                src="/img/dashboard/countiesIcon.png"
                style={{
                  maxWidth: mobileSize
                    ? "5.5rem"
                    : between1200and1405
                    ? "5.5rem"
                    : "6.5rem",
                  height: "auto",
                  margin: 0,
                }}
              />
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default TotalCounties;
